import { render, staticRenderFns } from "./MobHomeFlowCore.vue?vue&type=template&id=67219150&scoped=true"
import script from "./MobHomeFlowCore.vue?vue&type=script&setup=true&lang=js"
export * from "./MobHomeFlowCore.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobHomeFlowCore.vue?vue&type=style&index=0&id=67219150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67219150",
  null
  
)

export default component.exports